enum ImageLightBoxTypeEnum {
  none = 'none',
  author = 'author',
  metadata = 'metadata',
}

export default ImageLightBoxTypeEnum;
